// extracted by mini-css-extract-plugin
module.exports = {"player":"_649JW2UT","selector":"S4arrHjL","active":"_3RP0QFdl","videoContainer":"_1Q2WiKuJ"};
    if(module.hot) {
      // 1754514958897
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  